import * as ACT from './actions'
import { createReducer } from 'redux-create-reducer'
import update from 'immutability-helper'

const initialState = {
  name: '',
  value: '',
  dueDate: '',
  status: '',
  assignee: {},
  approvedAt: null,
  approvedBy: [],
  sentForReviewAt: null,
  sentForReviewTo: [],
  deal: {
    name: '',
    dealCompanies: [],
    internalTeam: []
  },
  tasks: [],
  company: {},
  emailBody: '',
  contacts: [],
  showProposalFollowup: false
}

const proposalReducer = createReducer(initialState, {
  [ACT.PROPOSAL_FETCH_SUCCESS](state, action) {
    const { proposal } = action.payload
    return {
      ...state,
      ...proposal
    }
  },
  [ACT.CLEAR_PROPOSAL_FROM_STORE]() {
    return {
      ...initialState
    }
  },
  [ACT.PROPOSAL_UPDATE_SUCCESS](state, action) {
    const { proposal } = action.payload
    return {
      ...state,
      ...proposal
    }
  },
  [ACT.PROPOSAL_TASKS_FETCH_SUCCESS](state, action) {
    const { tasks, proposalName } = action.payload
    return {
      ...state,
      tasks,
      name: proposalName
    }
  },
  [ACT.PROPOSAL_TASK_MARK_COMPLETED_SUCCESS](state, action) {
    const { task } = action.payload
    const index = state.tasks.findIndex(t => t.id === task.id)
    return update(state, {
      tasks: {
        [index]: { $set: task }
      }
    })
  },
  [ACT.UPDATE_PROPOSAL_TASK_SUCCESS](state, action) {
    const { task } = action.payload
    const index = state.tasks.findIndex(t => t.id === task.id)
    return update(state, {
      tasks: {
        [index]: { $set: task }
      }
    })
  },
  [ACT.DELETE_PROPOSAL_TASK_SUCCESS](state, action) {
    const { task } = action.payload
    const index = state.tasks.findIndex(t => +t.id === task.id)
    return update(state, {
      tasks: {
        $splice: [[index, 1]]
      }
    })
  },
  [ACT.CREATE_PROPOSAL_TASK_SUCCESS](state, action) {
    const { task } = action.payload
    return update(state, {
      tasks: { $push: task }
    })
  },
  [ACT.UPDATE_PROPOSAL_HTML_SUCCESS](state, action) {
    const { proposal } = action.payload
    return {
      ...state,
      ...proposal
    }
  },
  [ACT.EMAIL_PROPOSAL_TO_CLIENT_SUCCESS](state, action) {
    const { proposal } = action.payload
    const { status } = proposal
    return {
      ...state,
      status
    }
  },
  [ACT.PROPOSAL_APPROVE_SUCCESS](state, action) {
    const { proposal } = action.payload
    return {
      ...state,
      ...proposal
    }
  },
  [ACT.PROPOSAL_CONTACTS_HISTOY_FETCH_SUCCESS](state, action) {
    const { contacts } = action.payload
    return {
      ...state,
      contacts
    }
  },
  [ACT.PROPOSAL_SEND_FOR_REVIEW_SUCCESS](state, action) {
    const { proposal } = action.payload
    return {
      ...state,
      ...proposal
    }
  },
  [ACT.SHOW_PROPOSAL_FOLLOWUP](state, action) {
    const { showProposalFollowup } = action.payload
    return {
      ...state,
      showProposalFollowup
    }
  }
})

export default proposalReducer
